/**
 * device service
 */

import Resource from './resource'

export default new Resource('equipment')



// WEBPACK FOOTER //
// ./src/libraries/services/equipment.js